import { apiClient } from './requestInterceptor';

export interface Session {
    sessionId: string;
    entryAgent: string;
    provider: string;
    preview: string;
    createdAt: number;
    updatedAt: number;
}

interface SessionsResponse {
    sessions: Session[];
}

export interface SessionDetails {
    sessionId: string;
    provider: string;
    createdAt: number;
    updatedAt: number;
    data: any[];
}

export async function fetchSessions(userKey: string, projectKey: string, timeRange: string, limit: number = 20, offset: number = 0): Promise<Session[]> {
    const response = await apiClient(`/sessions?projectKey=${projectKey}&timeRange=${timeRange}&limit=${limit}&offset=${offset}`, userKey);
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    const data: SessionsResponse = await response.json();
    return data.sessions;
}

export async function fetchSessionDetails(userKey: string, projectKey: string, sessionId: string): Promise<SessionDetails> {
    const response = await apiClient(`/sessions/${sessionId}?projectKey=${projectKey}`, userKey);
    if (!response.ok) throw new Error('Failed To Retrieve Data');
    return response.json();
}
